export default class AudioEncoder {
  constructor() {
    this.worker = new Worker("./audio-processing/opus_encoder_worker.js");
  }

  setup(config) {
    var _this = this;
    return new Promise(function (resolve, reject) {
      _this.worker.onmessage = function (ev) {
        if (ev.data.status !== 0) {
          reject(ev.data);
          return;
        }
        resolve(ev.data.packets);
      };
      _this.worker.onerror = function (error) {
        reject(error);
      };
      _this.worker.postMessage({ command: "setup", config });
    });
  }

  encode(data) {
    var _this = this;
    return new Promise(function (resolve, reject) {
      _this.worker.onmessage = function (ev) {
        if (ev.data.status !== 0) {
          reject(ev.data);
          return;
        }
        resolve(ev.data.packets);
      };
      _this.worker.onerror = function (error) {
        reject(error);
      };
      _this.worker.postMessage({ command: "encode", data });
    });
  }
}
